import { FC, ChangeEvent, ReactNode } from 'react';
import { SwitchIndicator, withStyles } from 'vopay';
import styles from './Toggle.module.scss';

const cn = withStyles(styles);

type ToggleProps = {
  label?: ReactNode;
  name: string;
  checked: boolean;
  className?: string;
  readOnly?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
};

const Toggle: FC<ToggleProps> = ({ label, name, checked, className, readOnly = false, onChange = () => {} }) => {
  return (
    <div className={cn('toggleContainer', className)}>
      {label && label}
      <label htmlFor={`checkbox-${name}`} className={cn(readOnly && 'readOnly')}>
        <SwitchIndicator checked={checked} />
        <input id={`checkbox-${name}`} type="checkbox" name={name} checked={checked} onChange={(e) => onChange(e)} />
      </label>
    </div>
  );
};

export default Toggle;
